import axios from 'axios'

//const ERR_OK = 0

const get = (url) => {
    return function (params) {
        return axios.get(url, {
            params
        }).then((res) => {
            return res.data
        }).catch(() => {})
    }
}

const post = (url) => {
    return function (params) {
        return axios.post(url,params,{
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then((res) => {
            return res.data
        }).catch(() => {})
    }
}

export {
    get,
    post
}
